import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
} from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import {
  getAuth,
  provideAuth,
} from '@angular/fire/auth';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withDebugTracing } from '@angular/router';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { catchError, firstValueFrom, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient
) => new TranslateHttpLoader(http, './assets/i18n/', '.json');

export function appInitializerFactory(translate: TranslateService) {
  return (): Promise<any> => {
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');

    return firstValueFrom(
      translate.use('es').pipe(
        catchError((error) => {
          console.error(
            `Error loading translation file for language: es`,
            error
          );
          return of(null);
        })
      )
    );
  };
}

// Firebase config
const fbApp = () => initializeApp(environment.firebase);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes, withComponentInputBinding(), withDebugTracing()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
        defaultLanguage: 'es',
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, TranslateModule],
      multi: true,
    },

    provideEnvironmentNgxMask(),
    provideClientHydration(),
    provideAnimations(),
    provideFirebaseApp(fbApp),
    provideAuth(() =>getAuth()),
  ],
};
